import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IRol } from 'src/app/core/interfaces/DB/i-rols';

@Component({
  selector: 'app-perm',
  templateUrl: './perm.component.html',
  styleUrls: ['./perm.component.scss']
})
export class PermComponent implements OnInit {

  RolForm : FormGroup;
  DataRol :IRol;

  constructor(
    private formBuilder : FormBuilder,
    public dialogRef: MatDialogRef<PermComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IRol
  ) { }

 
  ngOnInit(): void {
    this.RolForm = this.createRolForm();
  }
   // METODO PARA CREAR EL FORMULARIO DE LOGIN
  private createRolForm(): FormGroup {
    return new FormGroup({
      // email: new FormControl('', Validators.compose([Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')])),
      name: new FormControl(this.data.Name, Validators.required),
      active: new FormControl(this.data.Active ? '1' : '0')
    });
  }
  getErrorMessage() {
    if (this.RolForm.controls['name'].hasError('required')) {
      return 'El nombre es requerido';
    }

    return this.RolForm.controls['name'].hasError('name') ? 'No es un nombre válido' : '';
  }
  getErrorMessageStatus(){
    if (this.RolForm.controls['active'].hasError('required')) {
      return 'El estado es requerido';
    }
    return this.RolForm.controls['active'].hasError('active') ? 'No es un estado válido' : '';
  }
  onNoClick(): void {
  
     this.dialogRef.close();
   
   
  }
 
  OnSubmit(): void {
    
    if(this.RolForm.valid){
      let formDta = this.RolForm.value;
      this.data = {
        Id: this.data.Id,
        Name: formDta.name,
        Active: formDta.active == '1',
      }
      this.dialogRef.close(this.data);
    }
   
  }


}
